import { render, staticRenderFns } from "./overview_tabs.vue?vue&type=template&id=c7bf192e"
import script from "./overview_tabs.vue?vue&type=script&lang=js"
export * from "./overview_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports